import React, { useCallback } from "react";
import "./files-drop-zone.component.scoped.scss";
import { useTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";
import { fileTypes } from "../../statics/file-types";

const FilesDropZone = (props: any) => {
  const [t] = useTranslation();
  const onDrop = useCallback((acceptedFiles) => {
    props.onDropFiles(acceptedFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { getRootProps, isDragActive } = useDropzone({
    onDrop,
    accept: fileTypes,
  });

  return (
    <div {...getRootProps({ className: "dropzone" })}>
      {isDragActive && !props.disabled ? (
        <div className="dropzone-overlay">
          <div className="drop-img">
            <img src="/file-upload.png" alt="" />
          </div>
          <h3 className="drop-title">{t("case.upload-files")}</h3>
          <p className="drop-text">{t("case.release the file to upload")}</p>
        </div>
      ) : null}
      {props.children}
    </div>
  );
};

export default FilesDropZone;
